import type { RoutesPlannerTask } from '@bringg-frontend/routes-planner';
import { TaskTypeId } from '@bringg/types';

const isPriorityValid = (
	task: RoutesPlannerTask,
	selectedTasksIds: number[],
	newPriority: number,
	linkedTasksNotValid: RoutesPlannerTask[]
): boolean => {
	if (task.linked_task_id && selectedTasksIds.includes(task.linked_task_id)) {
		const isPickupPriorityValid = task.task_type_id === TaskTypeId.PICKUP && task.priority < newPriority;
		const isDropOffPriorityValid = task.task_type_id === TaskTypeId.DELIVERY && task.priority > newPriority;
		if (isPickupPriorityValid || isDropOffPriorityValid) {
			return true;
		}
		linkedTasksNotValid.push(task);
		return false;
	}
	return true;
};
export const linkedTaskPriorityChecker = { isPriorityValid };
